import React from 'react'
import * as UI from '@brewlogix/blx-ui'
import classNames from 'classnames'
import { mapStore } from '../../state/mapStore'

interface IProfileButton {
    label: 'Driving' | 'Cycling' | 'Walking'
    onClick: () => void
    iconSlug: string
}

const ProfileButton: React.FC<IProfileButton> = ({ iconSlug, label, onClick }) => {
    const activeTab = mapStore((state) => state.activeTab)
    const profile = mapStore((state) => state.profile)
    const getIconClasses = (iconProfile: string, activeTab: string) => {
        return classNames(
            `profile--${iconProfile} p-2`,
            activeTab === 'routes'
                ? profile === iconProfile
                    ? 'text-primary'
                    : 'text-dark hover:text-primary'
                : ''
        )
    }
    const classes = getIconClasses(label.toLowerCase(), activeTab)

    return (
        <UI.Button
            icon={iconSlug}
            theme='link'
            customClasses={classes}
            size='sm'
            onClick={onClick}
            disabled={activeTab === 'breweries'}
            hiddenText
            label={label}
        />
    )
}
export default ProfileButton
